import { observer } from 'mobx-react';
import React from 'react';
import { Table, TableCell, TableRow } from 'telia-front-react';
import { TranslationsContext } from '@teliaee/telia-translate';
import { formatPrice } from '../../util/PriceUtil';

interface Props {
  totalPrice: number;
}

@observer
class TotalPriceTable extends React.Component<Props> {
  static contextType = TranslationsContext;
  declare context: React.ContextType<typeof TranslationsContext>;
  public render() {
    const translate = this.context.translate;
    const { totalPrice } = this.props;
    return (
      <Table className="text__margin-none">
        <tbody>
          <TableRow>
            <TableCell valign="bottom">
              <p className="h5">{translate('mobileBusiness.form.total')}</p>
            </TableCell>
            <TableCell>
              <div className="text-right text-bold h4">
                <span className="h2">{formatPrice(totalPrice)}</span> {translate('mobileBusiness.eurPerMonth')}
              </div>
            </TableCell>
          </TableRow>
        </tbody>
      </Table>
    );
  }
}

export default TotalPriceTable;
